
import { IMapOptions } from '@interfaces/maps/Map.interface';
import { TTextType } from '@ts/storybook';
import { DATE_RANGE_MODE, Paths } from '@ts/ui-models';

export const normalizeIMapOptions = ({ oldEntity, newEntity }, attr: Paths<IMapOptions>, notify?: (message: TTextType) => void, errory?: (value: boolean) => void): IMapOptions => {
  switch (newEntity.mode) {
    case DATE_RANGE_MODE.DATE_RANGE:
      if (errory) errory(false);
      if (!newEntity.dateRange) {
        newEntity.dateRange = {
          from: new Date().toISOString(),
          to: new Date().toISOString(),
        };
      }

      const dateFrom = new Date(newEntity.dateRange.from);
      const dateTo = new Date(newEntity.dateRange.to);
      const oneMonthInMs = 30 * 24 * 60 * 60 * 1000; // 30 días en milisegundos

      if (dateTo.getTime() - dateFrom.getTime() > oneMonthInMs) {
        if (notify) notify("The date range cannot exceed 1 month.");
        if (errory) errory(true);

        /* if (attr === "dateRange.from") {
          // Si estoy editando "from", ajustar "to"
          newEntity.dateRange.to = new Date(dateFrom.getTime() + oneMonthInMs).toISOString();
        } else if (attr === "dateRange.to") {
          // Si estoy editando "to", ajustar "from"
          newEntity.dateRange.from = new Date(dateTo.getTime() - oneMonthInMs).toISOString();
        } */
      }

      if (dateTo.getTime() < dateFrom.getTime()) {
        if (notify) notify("The 'to' date cannot be earlier than the 'from' date.");
        if (errory) errory(true);

        /* if (attr === "dateRange.from") {
          newEntity.dateRange.to = new Date(dateFrom.getTime() + 1000).toISOString(); // Agrega 1s para evitar igualdad
        } else if (attr === "dateRange.to") {
          newEntity.dateRange.from = new Date(dateTo.getTime() - 1000).toISOString();
        } */
      }

      if (newEntity.now) {
        newEntity.dateRange.to = new Date().toISOString();

        if (new Date().getTime() - dateFrom.getTime() > oneMonthInMs) {
          newEntity.dateRange.from = new Date(new Date().getTime() - oneMonthInMs).toISOString();
        }
        if (errory) errory(false);
      }

      //Clean unnecesary values
      newEntity.lastSeconds = undefined;
      break;

    case DATE_RANGE_MODE.LAST_SECONDS:
      if (!newEntity.lastSeconds) {
        newEntity.lastSeconds = 5;
      }
      newEntity.now = true;
      newEntity.dateRange = undefined;
      break;

    case DATE_RANGE_MODE.LAST_12_HS:
    case DATE_RANGE_MODE.LAST_24_HS:
    case DATE_RANGE_MODE.TODAY:
    case DATE_RANGE_MODE.LAST_HOUR:
    case DATE_RANGE_MODE.THIS_WEEK:
    case DATE_RANGE_MODE.LAST_YEAR:
    case DATE_RANGE_MODE.LAST_MONTH:
    case DATE_RANGE_MODE.LAST_WEEK:
    case 'lastPosition':
      newEntity.now = true;
      break;

    default:
      newEntity.lastSeconds = undefined;
      newEntity.dateRange = undefined;
      break;
  }
  return newEntity;
};
